import Vue from "vue";
import VueRouter from "vue-router";

import routes from "./routes";
import NProgress from "nprogress"; // Progress 进度条
import "nprogress/nprogress.css";
import nProgress from "nprogress";
import { getToken } from "@/utils/service";
import Store from "../../../store/index";
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter);

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  nProgress.start();
  if (getToken()) {
    if (to.path === "/login") {
      next();
    } else {
      Store.dispatch("GetUserInfo").then(() => {
        next();
      });
    }
  } else {
    if (to.path === "/login") {
      next();
    } else {
      next("/login");
      // next()
    }
  }
});
router.afterEach(() => {
  NProgress.done(); // 结束Progress
});

export default router;
